<ng-container *ngIf="notification">
    <section class="notification">
        <div class="notification__content">
            <svg
                class="notification__content-icon"
                fill="none"
                height="15"
                viewBox="0 0 15 15"
                width="15"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.0195312 11.8799V0.819336H9.33011L7.34926 3.95738L9.33011 7.08711H1.4487V11.8799H0.0195312Z"
                    [attr.fill]="notification?.categoryColor"
                />
            </svg>

            <div class="notification__content-text">
                <span class="notification__content-text--highlight"
                    >{{ notification.TripId }} has a {{ notification.Category }} flag that needs to be resolved by
                    {{ notification.FollowUpTime | date: 'MM/dd/yyyy, HH:mm a' }}</span
                >
            </div>
        </div>

        <div class="notification__actions">
            <a
                mat-ripple
                class="btn-dark flex-center notification__actions-view"
                aria-label="View Service Request"
                (click)="onViewServiceRequest()"
            >
                View
            </a>
            <button mat-ripple class="btn-light" (click)="closeNotification()">Dismiss</button>
        </div>
    </section>
</ng-container>
